import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { SearchSuggestions, useSuggestions } from "@/components/site/SearchSuggestions";

export const NavSearch = ({ mobile = false, onDone }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(mobile);
  const [focused, setFocused] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  const data = useSuggestions(q, open && focused);

  useEffect(() => { if (open && !mobile) ref.current?.focus(); }, [open, mobile]);

  const go = (path) => { onDone?.(); setFocused(false); setQ(""); if (!mobile) setOpen(false); navigate(path); };
  const submit = (e) => {
    e.preventDefault();
    const v = q.trim();
    if (!v) return;
    go(`/stories?q=${encodeURIComponent(v)}`);
  };
  const onStory = (s) => go(`/story/${s.id}`);
  const onTerm = (t) => go(`/stories?q=${encodeURIComponent(t)}`);

  if (mobile) {
    return (
      <div className="relative mb-4">
        <form onSubmit={submit} data-testid="nav-mobile-search-form" className="flex border border-white/20 focus-within:border-[#E30613] transition-colors">
          <Search size={16} className="self-center ml-3 text-neutral-500" />
          <input data-testid="nav-mobile-search-input" value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => setFocused(true)} onBlur={() => setTimeout(() => setFocused(false), 120)} placeholder="Search stories" className="flex-1 bg-transparent px-3 py-3 text-sm outline-none placeholder:text-neutral-600 text-white" />
          <button type="submit" data-testid="nav-mobile-search-submit" className="px-4 text-[10px] uppercase tracking-[0.2em] font-bold text-[#E30613]">Go</button>
        </form>
        {focused && <SearchSuggestions data={data} q={q} onStory={onStory} onTerm={onTerm} className="mt-2" />}
      </div>
    );
  }

  return (
    <div className="relative">
      <form onSubmit={submit} data-testid="nav-search-form" className={`flex items-center border transition-[width,border-color] duration-300 h-11 ${open ? "w-64 border-white/60" : "w-11 border-white/20 hover:border-white/60"}`}>
        <button type="button" data-testid="nav-search-toggle" aria-label="Search stories" onClick={() => setOpen((v) => !v)} className="w-11 h-11 shrink-0 inline-flex items-center justify-center text-neutral-300 hover:text-white transition-colors">
          <Search size={17} />
        </button>
        <input
          ref={ref}
          data-testid="nav-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => { setTimeout(() => setFocused(false), 120); if (!q) setOpen(false); }}
          placeholder="Search artists, topics, stories"
          className={`bg-transparent text-sm text-white outline-none placeholder:text-neutral-600 transition-opacity duration-200 ${open ? "w-full pr-3 opacity-100" : "w-0 opacity-0 pointer-events-none"}`}
        />
      </form>
      {open && focused && <SearchSuggestions data={data} q={q} onStory={onStory} onTerm={onTerm} className="absolute right-0 top-full mt-2 w-[360px] z-[1100]" />}
    </div>
  );
};
